<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <!-- <img style="display: none;" id='reportLogo' crossorigin="Anonymous" :src="imagepath" alt='Report Logo'> -->
        <div class="row no-gutters">
            <div class="col-md-12">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site" >
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="currentProfile === 'sales_order_journals'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7"> 
                                    <base-input alternative="" label="Customer">
                                        <a-select mode="multiple" v-model="inputCustomers" showSearch placeholder="All Customers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" allowClear>
                                            <a-select-option v-for="option in customerOptions" :key="option.id" :value="option.id">{{option.name || option.code}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                    </button>
                                </div>
                            </div>

                            <div class="row" v-if="currentProfile === 'sales_invoice_journals'">
                                <div class="col-md-7">
                                    <base-input label="Format" >
                                        <select class="form-control" size="large" v-model="inputFormat">
                                            <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row" v-if="currentProfile == 'sales_invoice_journals'">
                                <div class="col-md-7"> 
                                    <base-input alternative="" label="Company">
                                        <a-select mode="multiple" v-model="inputCompanies" showSearch placeholder="All Company" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in companyOptions" :key="option.id" :value="option.id">{{option.name || option.code}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row" v-if="currentProfile == 'sales_invoice_journals' && (inputFormat == '2' ||inputFormat == 2)">
                                <div class="col-md-7"> 
                                    <base-input label="RDO" maxlength="3" v-model="rdoField"  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))">
                                    </base-input>
                                </div>
                            </div>
                            <div class="row" v-if="currentProfile == 'sales_invoice_journals' && (inputFormat == '2' ||inputFormat == 2)">
                                <div class="col-md-7"> 
                                    <base-input label="Quarter" maxlength="2" v-model="quarterField"  onkeypress="return ((event.charCode !=8 && event.charCode ==0 || ((event.charCode >= 49 && event.charCode <= 57) && event.charCode !=52 && event.charCode !=53 && event.charCode !=55 && event.charCode !=56)) && [3,6,9,1,12].includes(Number(event.target.value + event.key) || 0))">
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Status" >
                                        <select class="form-control" size="large" v-model="inputStatus">
                                            <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row" v-if="['sales_order_journals','price_work_sheet_journals'].includes(currentProfile)">
                                <div class="col-md-7">
                                    <base-input label="Brand">
                                        <a-select showSearch v-model="inputBrands" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All Brand" allowClear @select="getSubBrandData" @change="clearSubBrand">
                                            <a-select-option v-for="brandOption in brandOptions" :key="brandOption.id" :value="brandOption.id">{{brandOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row" v-if="$attrs.friendlyCode != 'RR' && $attrs.friendlyCode != 'RS' && $attrs.friendlyCode != 'ADI' && $attrs.friendlyCode != 'STI'">
                                <div class="col-md-7">
                                    <base-input label="Order Status" v-if="currentProfile !== 'price_work_sheet_journals' && currentProfile !== 'sublocation_transfer_out_journals'">
                                        <a-select mode="multiple" v-model="inputOrderStatus" showSearch placeholder="All Status" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" allowClear>
                                            <a-select-option v-for="option in orderStatusOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row" v-if="currentProfile == 'adjustment_in_journals'">
                                <div class="col-md-7">
                                    <base-input label="Order Source" >
                                        <a-select mode="multiple" v-model="inputOrderSource" showSearch placeholder="All Source" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in orderSourceOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <base-dropdown class="nav-link pr-0 float-right" style="margin: 10px 10px" position="right">
                    <div class="media align-items-center" slot="title">
                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                    </div>
                    <template>
                    <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">ACTIONS</h6>
                    </div>
                    <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                        <i class="fa fa-list-ul"></i>
                        <span>Customize List</span>
                    </div>
                    </template>
                </base-dropdown>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <br>
                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                
                
                <button v-if="JsonData.length < 1 && !flatFileReports.includes(currentProfile)" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                
                <button v-if="JsonData.length < 1 && flatFileReports.includes(currentProfile)" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%; ; margin-right: 8px;" @click.prevent="generateFlatFile">Generate Report</button> &nbsp; &nbsp;
                
                <vue-json-to-csv v-if="JsonData.length > 0 && (inputFormat !== '3' && inputFormat !== 3)"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                </vue-json-to-csv>
                <download-excel v-if="JsonData.length > 0 && (inputFormat !== '3' && inputFormat !== 3)" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                </download-excel>
                <button v-if="JsonData.length > 0 && currentProfile === 'sales_invoice_journals' && (inputFormat == '3' ||inputFormat == 3)" @click.prevent="downloadCSV" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;">Download CSV</button>
                <button v-if="JsonData.length > 0 && currentProfile === 'sales_invoice_journals' && (inputFormat == '3' ||inputFormat == 3)" @click.prevent="downloadExcel" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;">Download Excel</button>
                <button v-if="JsonData.length > 0 && currentProfile === 'sales_invoice_journals' && (inputFormat == '2' ||inputFormat == 2)" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="saveDatFile">Download DAT</button> &nbsp; &nbsp;
            </div>
        </div>

        <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
            <div v-if="profileAction == 'customize_list'">
                <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Header" key="1">
                        <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
                            <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                <div class="row">
                                    <div class="col-md-9">
                                        AVAILABLE FIELDS
                                    </div>
                                    <div class="col-md-3">
                                        <a-checkbox @change="onCheckAllField" :checked="checkedHeaderFields.length == availableFields.length" class="float-right" />
                                    </div>
                                </div>
                            </li>

                            <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields" v-bind:key="field">
                                <div class="row">
                                    <div class="col-md-9">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{_.startCase(field)}}
                                    </div>
                                    <div class="col-md-3">
                                        <a-checkbox @change="onCheckField(field)" :checked="checkedHeaderFields.includes(field)" :disabled="defaultCheckedHeaderFields.includes(field)" class="float-right" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </a-tab-pane>
                    <a-tab-pane tab="Lines" key="2">
                        <ul v-if="availableDetailFields.length > 0" class="list-group list-group-flush" style="width: 100%">
                            <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                <div class="row">
                                    <div class="col-md-9">
                                        AVAILABLE FIELDS
                                    </div>
                                    <div class="col-md-3">
                                        <a-checkbox @change="onCheckAllDetailField" :checked="checkedDetailFields.length == availableDetailFields.length" class="float-right" />
                                    </div>
                                </div>
                            </li>

                            <li class="list-group-item" style="font-size: 14px" v-for="field in availableDetailFields" v-bind:key="field">
                                <div class="row">
                                    <div class="col-md-9">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{_.startCase(field)}}
                                    </div>
                                    <div class="col-md-3">
                                        <a-checkbox @change="onCheckDetailField(field)" :checked="checkedDetailFields.includes(field)" :disabled="defaultCheckedDetailFields.includes(field)" class="float-right" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </a-tab-pane>
                </a-tabs>
                
            </div>
        </a-drawer>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { dissectReportFilters } from '../../components/reportUtils';
    import { getReportDescription,decrypt } from '../../utilities';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                // imagepath: secureStorage.getItem("account_logo"),
                flatFileReports: ["purchase_request_journals", "purchase_return_journals", "advance_shipment_notice_journals", "purchase_order_journals", "receiving_report_journals", "sales_order_journals", "sales_invoice_journals", "delivery_document_journals", "sublocation_transfer_out_journals", "price_work_sheet_journals", "adjustment_in_journals"],
                // receiving_report_journals
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputStatus: 'P',
                statusOptions: [
                    {key: 'P', value: 'Posted'},
                    {key: 'S', value: 'Saved'},
                    {key: 'V', value: 'Voided'},
                    {key: '', value: 'All'}
                ],
                inputSortBy: 'id',
                sortOptions: [
                    {key: 'id', value: 'Document ID'}
                ],
                inputOrderStatus: [],
                orderStatusOptions: [
                    {key: "U", value: "Unfulfilled"},
                    {key: "G", value: "Goods Issued"},
                    {key: "F", value: "Fulfilled"},
                    {key: "O", value: "Open Delivery"},
                    {key: "S", value: "Paid"},
                    {key: "P", value: "Partial"},
                    {key: "D", value: "Done"}
                ],
                inputFormat: 1,
                formatOptions: [
                    {key: '1', value: 'Simple'},
                    {key: '2', value: 'Summary List of Sales'},
                    {key: '3', value: 'Summary'},

                ],
                inputCompanies: [],
                companyOptions: [],
                inputBrands: [],
                brandOptions: [],
                rdoField:null,
                quarterField:null,
                transOptions: [
                    {key: "RECADJ", value: "Adjustment In", friendly_code: "ADI"},
                    {key: "RELADJ", value: "Adjustment Out", friendly_code: "ADO"},
                    {key: "ORIASN", value: "Advance Shipment Notice", friendly_code: "ASN"},
                    {key: "OTHASM", value: "Assemble", friendly_code: "ASM"},
                    {key: "OTHBIN", value: "Branch Inventory", friendly_code: "BIN"},
                    {key: "OTHCPO", value: "Consolidated PO", friendly_code: "CPO"},
                    {key: "ORICSQ", value: "Concession Transfer Request", friendly_code: "CSQI"},
                    {key: "OROCSQ", value: "Concession Transfer Order", friendly_code: "CSQO"},
                    {key: "RELCSX", value: "Concession Transfer Out", friendly_code: "CTO"},
                    {key: "RECCSX", value: "Concession Transfer In", friendly_code: "CTI"},
                    {key: "RELCSI", value: "Concession Sales", friendly_code: "CSI"},
                    {key: "RECCSI", value: "Concession Returns", friendly_code: "CRS"},
                    {key: "OTHDSM", value: "Disassemble", friendly_code: "DSM"},
                    {key: "RELDDE", value: "Delivery Document", friendly_code: "DDE"},
                    {key: "OTHPWS", value: "Price Work Sheet", friendly_code: "PWS"},
                    {key: "OTHPCN", value: "Physical Count", friendly_code: "PCN"},
                    {key: "RELPOS", value: "POS Sales", friendly_code: "TSI"},
                    {key: "OROPOS", value: "POS Reservations", friendly_code: "RSNV"},
                    {key: "RECPOS", value: "POS Returns", friendly_code: "TCSR"},
                    {key: "OTHPUR", value: "Purchase Request", friendly_code: "PR"},
                    {key: "ORIPOX", value: "Purchase Order", friendly_code: "PO"},
                    {key: "OTHQUO", value: "Quotation", friendly_code: "QUO"},
                    {key: "RECDEL", value: "Receiving Report", friendly_code: "RR"},
                    {key: "RELRSR", value: "Purchase Return", friendly_code: "PRT"},
                    {key: "RELSLO", value: "Sublocation Transfer Out", friendly_code: "SLO"},
                    {key: "RECSLI", value: "Sublocation Transfer In", friendly_code: "SLI"},
                    {key: "ORISOX", value: "Sales Order", friendly_code: "SO"},
                    {key: "OTHSIN", value: "Sales Invoice", friendly_code: "SI"},
                    {key: "OTHSBI", value: "Suppliers Bill", friendly_code: "SB"},
                    {key: "ORITRQ", value: "Transfer Request", friendly_code: "TRQ"},
                    {key: "OROTRQ", value: "Transfer Order", friendly_code: "STR"},
                    {key: "RELTRX", value: "Transfer Out", friendly_code: "STO"},
                    {key: "RECTRX", value: "Transfer In", friendly_code: "STI"},
                ],
                inputSite: [],
                site_type: "ho",
                showSortInfo: 'asc',
                drawerVisible: false,
                profileAction: '',
                availableFields: [],
                availableDetailFields: [],
                
                customDetailFields: ["stock_no"],
                customHeaderFields: ["party_name", "posted_at", "origin_document_date"],

                defaultCheckedDetailFields: ["stock_no", "barcode", "product_name", "brand_name", "quantity"],
                defaultCheckedHeaderFields: ["document_no", "party_name", "document_date", "posted_at", "status"],

                checkedDetailFields: ["stock_no", "barcode", "product_name", "brand_name" , "company_name", "quantity"],
                checkedHeaderFields: ["document_no", "party_name", "document_date", "posted_at", "origin_document_no", "origin_document_date", "status"],
                
                siteOptions: [],
                inputCustomers: [],
                customerOptions: [],
                birSalesReports: [],
                JsonData: [],
                userProductGroupAccess: [],
                reportDescription: '',
                inputOrderSource: [],
                orderSourceOptions: [
                    { key: '', value: 'All'},
                    { key: 'pcv', value: 'PCV'},
                    { key: 'tov', value: 'TOV'},
                    { key: 'regular', value: 'Regular'},
                    { key: 'ecomm', value: 'Ecomm'},
                    { key: 'barter_tool', value: 'Barter Tool'},
                    { key: 'barter_tool_3p', value: 'Barter Tool 3P'},
                    { key: 'liquidation', value: 'Liquidation'}
                ]
            }
        },          
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            var customer = await HTTPRequest.getRequest(component_x.endPoint + "b2b_customers/get_valid_b2b_customers?mode=all", null);
            component_x.customerOptions = customer;
            component_x.sort(component_x.customerOptions);

            var company = await HTTPRequest.getRequest(component_x.endPoint + "companies/get_valid_companies?mode=all", null);
            component_x.companyOptions = company;
            component_x.sort(component_x.companyOptions);


            let siteId = secureStorage.getItem("defaultSiteId")
            //this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            let userGroupPermission = await HTTPRequest.getRequest(this.endPoint + "/user_memberships/get_user_group_permissions?system_module_name='products'&user_id=" + userId, null )
            if(userGroupPermission != null){
                this.userProductGroupAccess = userGroupPermission.access_right
            }

            const operationsReport = localStorage.getItem(this.currentProfile + "operationsReport")
            // console.log(operationsReport)
            if(operationsReport != undefined && operationsReport != null && operationsReport != "[]"){
                this.checkedHeaderFields = JSON.parse(operationsReport)
            }else{
                localStorage.removeItem(this.currentProfile+ "operationsReport")
            }
            const operationsReportDetail = localStorage.getItem(this.currentProfile + "operationsReportDetail")
            // console.log(operationsReport)
            if(operationsReportDetail != undefined && operationsReportDetail != null && operationsReportDetail != "[]"){
                this.checkedDetailFields = JSON.parse(operationsReportDetail)
            }else{
                localStorage.removeItem(this.currentProfile + "operationsReportDetail")
            }
            await component_x.getBrandOptions();
            component_x.reportDescription = await getReportDescription(this.currentProfile)
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            onClose() {
                this.drawerVisible = false
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            saveDatFile(){
                let data = ""
                if(this.inputFormat == 2){
                    this.JsonData.forEach(function(obj) {
                        const newItems = Object.entries(obj).reduce((ac, cu) => {
                        return [...ac, cu[1]];
                        }, [])
                        data+=newItems.join(",")+"\n"
                    });
                }

                const blob = new Blob([data], {type: 'text/plain'})
                const e = document.createEvent('MouseEvents'),
                a = document.createElement('a');
                a.download = this.currentProfile.replace(/_/g, '-')+'-'+this.currDate.replace(/ /g, '')+".dat";
                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
                this.clearJsonData()
            },
            async showActionDrawer(action) {
                if (action == "customize_list") {
                    let response = await HTTPRequest.getRequest(this.endPoint + "documents/get_viewable_fields", null)
                    this.availableFields = response["fields"]
                    this.availableFields = this.customHeaderFields.concat(this.availableFields)

                    let detailresponse = await HTTPRequest.getRequest(this.endPoint + "document_lines/get_viewable_fields", null)
                    this.availableDetailFields = detailresponse["fields"]
                                        
                    if(!this.userProductGroupAccess.includes("Z")){
                        this.availableDetailFields = this.availableDetailFields.filter(e => e !== "cost")
                    }
                    if(!this.userProductGroupAccess.includes("Y")){
                        this.availableDetailFields = this.availableDetailFields.filter(e => e !== "price")
                    }

                    this.availableDetailFields = this.customDetailFields.concat(this.availableDetailFields)

                }

                this.profileAction = action
                this.drawerVisible = true
            },
            rejectReference(data){
                let strData = JSON.stringify(data)
                let parseData = JSON.parse(strData)
                return parseData;
            },
            onCheckAllDetailField() {     
                if(this.checkedDetailFields.length == this.availableDetailFields.length){
                    this.checkedDetailFields = this.rejectReference(this.defaultCheckedDetailFields)
                } else {
                    this.checkedDetailFields = this.rejectReference(this.defaultCheckedDetailFields)

                    for(let v=0; v < this.availableDetailFields.length; v++){
                        let fieldName = this.availableDetailFields[v]
                        if(this.checkedDetailFields.includes(fieldName)){
                            //do nothing
                        } else {
                            this.checkedDetailFields.push(fieldName)
                        }
                    }
                }
                let storeName = this.currentProfile + "operationsReportDetail" 
                localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
            },
            onCheckDetailField(fieldName) {
                if(this.checkedDetailFields.includes(fieldName)){
                    var indexValue = this.checkedDetailFields.indexOf(fieldName)
                    if (indexValue > -1) 
                        var indexValue2 = this.checkedDetailFields.indexOf(fieldName)
                    if (indexValue2 > -1) 
                        this.checkedDetailFields.splice(indexValue2, 1)
                }else{
                    this.checkedDetailFields.push(fieldName)
                }
                let storeName = this.currentProfile + "operationsReportDetail" 
                localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
            },
            onCheckAllField() {     
                if(this.checkedHeaderFields.length == this.availableFields.length){
                    this.checkedHeaderFields = this.rejectReference(this.defaultCheckedHeaderFields)
                } else {
                    this.checkedHeaderFields = this.rejectReference(this.defaultCheckedHeaderFields)
                    for(let v=0; v < this.availableFields.length; v++){
                        let fieldName = this.availableFields[v]
                        if(this.checkedHeaderFields.includes(fieldName)){
                            //do nothing
                        } else {
                            this.checkedHeaderFields.push(fieldName)
                        }
                    }
                }
                let storeName = this.currentProfile + "operationsReport" 
                localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
            },
            onCheckField(fieldName) {
                if(this.checkedHeaderFields.includes(fieldName)){
                    var indexValue = this.checkedHeaderFields.indexOf(fieldName)
                    if (indexValue > -1) 
                        var indexValue2 = this.checkedHeaderFields.indexOf(fieldName)
                    if (indexValue2 > -1) 
                        this.checkedHeaderFields.splice(indexValue2, 1)
                }else{
                    this.checkedHeaderFields.push(fieldName)
                }
                let storeName = this.currentProfile + "operationsReport" 
                localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let grandTotalQuantity = 0;
                let grandTotalPrice = 0;
                let grandTotalNetSubtotal = 0;
                let grandTotal = 0;
                let grandTotalSRP = 0;

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from":  this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to":  this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "type": this.$attrs.friendlyCode,
                    "status": this.inputStatus,
                    "order_status": this.inputOrderStatus,
                    "order_source": this.inputOrderSource
                }

                // var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null);
                parameters.current_profile = this.currentProfile
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?', parameters, null);
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks", "brand_name","price", "company_name"]
                //let reportLogo = document.getElementById('reportLogo');
                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let trans_friendly_code = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).friendly_code

                    let header_prefix = trans_friendly_code
                    let origin_prefix = 'Origin Doc'
                    let party = 'Party'

                    if(header_prefix == 'RR'){
                        origin_prefix = 'ASN'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'ASN'){
                        origin_prefix = 'PO'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'PO'){
                        origin_prefix = 'PR'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'PRT'){
                        origin_prefix = 'RR'
                        party = 'Supplier'
                    }
                    if (this.currentProfile === "sales_order_journals" || this.currentProfile === "sales_invoice_journals" || this.currentProfile === 'delivery_document_journals') {
                        this.checkedHeaderFields = [
                            ...this.checkedHeaderFields,   
                            "company_name",                // SBU
                            "amount_net",                  // Amount
                            "discount",                    // Discount
                            "b2b_customer_name",           // Customer
                            "customer_type"                // Customer Type
                        ];

                        this.checkedDetailFields = [
                            ...this.checkedDetailFields,   
                            "price",
                            "subtotal"   
                        ];

                        const index = this.checkedDetailFields.indexOf('barcode');
                        if (index !== -1) {
                            this.checkedDetailFields = [
                                ...this.checkedDetailFields.slice(0, index + 1), 
                                'brand_name',
                                ...this.checkedDetailFields.slice(index + 1),
                            ];
                        }
                    }

                    if (this.$attrs.friendlyCode == 'RECADJ'){
                        this.checkedHeaderFields = [
                                "order_source",
                                ...this.checkedHeaderFields,
                                "cas_no",
                                "purpose",
                                "reference",
                                "remarks"
                            ];

                        this.checkedDetailFields = [
                                ...this.checkedDetailFields,
                                "subtotal",
                            ];

                        this.checkedHeaderFields = this.checkedHeaderFields.filter(field => field !== "origin_document_no");
                        this.checkedHeaderFields = this.checkedHeaderFields.filter(field => field !== "origin_document_date");
                        this.checkedHeaderFields = this.checkedHeaderFields.map(field => field === "party_name" ? "site_name" : field);
                    }

                    let field_count = this.checkedHeaderFields.length
                    let header_count = this.checkedHeaderFields.length
                    let line_count = this.checkedDetailFields.length
                    if(field_count < line_count){
                        field_count = line_count
                    }


                    let footer_x = 340
                    let footer_y = 210

                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let header_remaining_width = 0
                    let line_remaining_width = 0
                    let header_plus = 30 //party_name = 30
                    let line_plus = 60 //product_name = 30 + indention = 30

                    if(field_count <= 11){
                        header_remaining_width = ((11 - header_count) * 30) - header_plus
                        line_remaining_width = ((11 - line_count) * 30) - line_plus
                    } else if(field_count <= 13) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3'});
                        header_remaining_width = ((13 - header_count) * 30) - header_plus
                        line_remaining_width = ((13 - line_count) * 30) - line_plus

                        footer_x = 410
                        footer_y = 290
                    } else if(field_count <= 16) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3'});
                        header_remaining_width = ((16 - header_count) * 30) - header_plus
                        line_remaining_width = ((16 - line_count) * 30) - line_plus

                        footer_x = 490
                        footer_y = 350
                    } else if(field_count <= 19) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2'});
                        header_remaining_width = ((19 - header_count) * 30) - header_plus
                        line_remaining_width = ((19 - line_count) * 30) - line_plus

                        footer_x = 580
                        footer_y = 415
                    } else if(field_count <= 23) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b2'});
                        header_remaining_width = ((23 - header_count) * 30) - header_plus
                        line_remaining_width = ((23 - line_count) * 30) - line_plus

                        footer_x = 680
                        footer_y = 490
                    } else if(field_count <= 27) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a1'});
                        header_remaining_width = ((27 - header_count) * 30) - header_plus
                        line_remaining_width = ((27 - line_count) * 30) - line_plus

                        footer_x = 820
                        footer_y = 590
                    } else if(field_count <= 32) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b1'});
                        header_remaining_width = ((32 - header_count) * 30) - header_plus
                        line_remaining_width = ((32 - line_count) * 30) - line_plus

                        footer_x = 950
                        footer_y = 700
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a0'});
                        header_remaining_width = ((39 - header_count) * 30) - header_plus
                        line_remaining_width = ((39 - line_count) * 30) - line_plus

                        footer_x = 1150
                        footer_y = 830
                    }

                    let header_fair_plus = header_remaining_width / header_count
                    let line_fair_plus = line_remaining_width / line_count
                    let headerColStyles = {}
                    let lineColStyles = {}

                    let dynamic_header = []
                    for(let v=0; v < this.checkedHeaderFields.length; v++){
                        if(this.checkedHeaderFields[v] == 'document_no'){
                            dynamic_header.push({content: `${header_prefix} #`, styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'party_name'){
                            dynamic_header.push({content: party, styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'document_date'){
                            dynamic_header.push({content: `${header_prefix} Date`, styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'posted_at'){
                            dynamic_header.push({content: `${header_prefix} Post Date`, styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'origin_document_no'){
                            dynamic_header.push({content: `${origin_prefix} #`, styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'origin_document_date'){
                            dynamic_header.push({content: `${origin_prefix} Date`, styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'company_name'){
                            dynamic_header.push({content: 'SBU', styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'b2b_customer_name'){
                            dynamic_header.push({content: 'Customer', styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'amount_net'){
                            dynamic_header.push({content: 'Amount', styles: {halign: 'center'}})
                        } else if(this.checkedHeaderFields[v] == 'site_name'){
                            dynamic_header.push('Target Branch')
                        } else if(this.checkedHeaderFields[v] == 'cas_no'){
                            dynamic_header.push('Cas Series #')
                        
                        } else {
                            let s = this.checkedHeaderFields[v]
                            let format_header = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_header.push({content: _.startCase(format_header), styles: {halign: 'center'}})
                        } 

                        if(this.checkedHeaderFields[v] == 'party_name'){
                            headerColStyles[v] = {cellWidth: 60 + header_fair_plus}
                        } else {
                            headerColStyles[v] = {cellWidth: 30 + header_fair_plus}    
                        }
                    }

                    let dynamic_line = []
                    for(let v=0; v < this.checkedDetailFields.length; v++){
                        if(this.checkedDetailFields[v] == 'stock_no'){
                            dynamic_line.push({content: 'Stock No.', styles: {halign: 'left'}})
                        } else if(this.checkedDetailFields[v] == 'product_name'){
                            dynamic_line.push({content: 'Description', styles: {halign: 'left'}})
                        } else if(this.checkedDetailFields[v] == 'quantity'){
                            dynamic_line.push({content: 'Quantity', styles: {halign: 'right'}})
                        } else if(this.checkedDetailFields[v] == 'brand_name'){
                            dynamic_line.push({content: 'Brand', styles: {halign: 'left'}})
                        } else if(this.checkedDetailFields[v] == 'price'){
                            dynamic_line.push({content: 'Price', styles: {halign: 'right'}})
                        } else if(this.checkedDetailFields[v] == 'subtotal'){
                            if(this.$attrs.friendlyCode == 'RECADJ') {
                                dynamic_line.push('Total SRP')
                            } else {
                                dynamic_line.push({content: 'Net Subtotal', styles: {halign: 'right'}})
                            }
                        }else {
                            let s = this.checkedDetailFields[v]
                            let format_detail = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_line.push({content: _.startCase(format_detail), styles: {halign: 'left'}})
                        } 

                        if(this.checkedDetailFields[v] == 'product_name'){
                            lineColStyles[v] = {cellWidth: 60 + line_fair_plus}
                        } else {
                            lineColStyles[v] = {cellWidth: 30 + line_fair_plus}    
                        }
                    }

                    for(var x=0; x < siteSpecific.length; x++){
                        //doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let design_y = 20

                        doc.text(15,design_y,`${trans_val} Journal`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                        if(x > 0){
                            //add new page
                            doc.addPage();
                        }

                        design_y = design_y + 5;
                        doc.text(15,design_y,`Site: ${siteSpecific[x].report_details[0].site_name}`)
                        let filterText = dissectReportFilters(parameters, this.displayOptions={}, this.formatOptions={})
                        const { basic } = filterText
                        doc.text(15, 35, `Filter/s: ${basic}`)

                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''
                        

                        if(this.birSalesReports.length > 0){
                            let headerData = []
                            let reportData = []
                            let subtotal = {}
                            

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let header_detail = []
                                let line_detail = []

                                if(grouper == ''){
                                    for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                        let field_value = this.checkedHeaderFields[vd]
                                        
                                        if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                            field_value = `document_${field_value}`
                                        }

                                        if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                            if(reportLine[field_value] == null){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push({content: moment(reportLine[field_value]).format('MM/DD/YYYY'), styles: {halign: 'center'}})
                                            }
                                        } else if (field_value == 'origin_document_no'){
                                            if(reportLine[field_value] == null || reportLine[field_value] == -1){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push({content: reportLine[field_value], styles: {halign: 'center'}})
                                            }
                                        } else if (field_value == 'document_status'){
                                            if(reportLine[field_value] == 'A'){
                                                header_detail.push({content: 'Active', styles: {halign: 'center'}})
                                            } else {
                                                let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                header_detail.push({content: status_val, styles: {halign: 'center'}})
                                            }
                                        } else {
                                            if(reportLine[field_value] == null){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push({content: reportLine[field_value], styles: {halign: 'center'}})
                                            }
                                        } 
                                    }

                                    headerData.push(header_detail)

                                    design_y = design_y + 10;

                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [dynamic_header],
                                        body: headerData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: headerColStyles
                                    });
                                } else {
                                    
                                    if(grouper != reportLine.document_id){
                                        //if new document display prev dostartcument details 
                                        reportData.push(Object.assign({}, ["rowLine"]))

                                        let sub_detail = []
                                        for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                            let field_value = this.checkedDetailFields[vd]
                                            if(field_value == 'product_name'){
                                                sub_detail.push("Sub Total")
                                            } else {
                                                if(subtotal[field_value] == undefined){
                                                    sub_detail.push('')
                                                } else {
                                                    if (this.currentProfile === 'sales_order_journals' || this.currentProfile === "sales_invoice_journals") {
                                                        if (field_value == 'quantity'){
                                                            grandTotalQuantity += parseFloat(subtotal[field_value])
                                                            sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                        } else if (field_value == 'subtotal'){
                                                            grandTotalNetSubtotal += parseFloat(subtotal[field_value])
                                                            sub_detail.push("")
                                                            sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                        }
                                                    } else {
                                                        if (this.$attrs.friendlyCode == 'RECADJ'){
                                                            grandTotalQuantity += parseFloat(subtotal['quantity'])
                                                            grandTotalSRP += parseFloat(subtotal['subtotal'])
                                                        } else {
                                                            grandTotal += parseFloat(subtotal[field_value])
                                                        }
                                                        sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                    }
                                                }
                                            }   
                                        }

                                        reportData.push(Object.assign({}, sub_detail))
                                        
                                        subtotal = {}

                                        doc.autoTable({
                                            head: [dynamic_line],
                                            body: reportData, 
                                            margin: {left: 30},
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            headStyles: {
                                                lineWidth: 0.15
                                            },
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: lineColStyles,
                                            didParseCell: function(data) {
                                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                    data.cell.styles.fillColor = [0, 0, 0]
                                                    data.cell.styles.fontSize = 1
                                                    data.cell.styles.cellPadding = 0
                                                } else if (data.row.section == 'body' && data.row.raw[3] == 'Sub Total'){
                                                    data.cell.styles.fontStyle = 'bold'
                                                }
                                            }
                                        });

                                        reportData = []
                                        headerData = []

                                        for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                            let field_value = this.checkedHeaderFields[vd]
                                            
                                            if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                field_value = `document_${field_value}`
                                            }

                                            if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push({content: moment(reportLine[field_value]).format('MM/DD/YYYY'), styles: {halign: 'center'}})
                                                }
                                            } else if (field_value == 'origin_document_no'){
                                                if(reportLine[field_value] == null || reportLine[field_value] == -1){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push({content: reportLine[field_value], styles: {halign: 'center'}})
                                                }
                                            } else if (field_value == 'document_status'){
                                                if(reportLine[field_value] == 'A'){
                                                    header_detail.push({content: 'Active', styles: {halign: 'center'}})
                                                } else {
                                                    let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                    header_detail.push({content: status_val, styles: {halign: 'center'}})
                                                }
                                            } else {
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push({content: reportLine[field_value], styles: {halign: 'center'}})
                                                }
                                            } 
                                        }

                                        headerData.push(header_detail)

                                        doc.autoTable({
                                            head: [dynamic_header],
                                            body: headerData, 
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            headStyles: {
                                                lineWidth: 0.15
                                            },
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: headerColStyles
                                        });
                                    }
                                }
                                
                                grouper = reportLine.document_id

                                for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                    let field_value = this.checkedDetailFields[vd]

                                    if(reportLine[field_value] == null){
                                        line_detail.push('')
                                    } else {
                                        // console.log(field_value, reportLine[field_value], typeof(reportLine[field_value]))
                                        let align = 'left'
                                        let convert_me = false
                                        if(no_subtotal.includes(field_value)){
                                            //dont total
                                        } else {
                                            if (typeof(reportLine[field_value]) == "string"){
                                                // console.log(parseFloat(reportLine[field_value]))
                                                // console.log(_.isNaN(parseFloat(reportLine[field_value])))
                                                if(_.isNaN(parseFloat(reportLine[field_value])) == false){
                                                    // console.log(subtotal[field_value])
                                                    if(subtotal[field_value] == undefined){
                                                        subtotal[field_value] = Number(reportLine[field_value])
                                                    } else {
                                                        subtotal[field_value] = subtotal[field_value] + Number(reportLine[field_value])
                                                    }

                                                    align = 'right'
                                                    convert_me = true
                                                }
                                                // console.log(subtotal)
                                            }
                                        }

                                        if(convert_me == true){
                                            line_detail.push({content: this.convertToCurrency(Number(reportLine[field_value])), styles: {halign: align}})
                                        } else {
                                            line_detail.push({content: reportLine[field_value], styles: {halign: align}})
                                        }
                                    }
                                }

                                reportData.push(line_detail)

                                if(i == this.birSalesReports.length-1){
                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    let sub_detail = []
                                    for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                        let field_value = this.checkedDetailFields[vd]
                                        if(field_value == 'product_name'){
                                            sub_detail.push("Sub Total")
                                        } else {
                                            if(subtotal[field_value] == undefined){
                                                sub_detail.push('')
                                            } else {
                                                if (this.currentProfile === 'sales_order_journals' || this.currentProfile === "sales_invoice_journals") {
                                                    if (field_value == 'quantity'){
                                                        grandTotalQuantity += parseFloat(subtotal[field_value])
                                                        sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                    } else if (field_value == 'subtotal'){
                                                        grandTotalNetSubtotal += parseFloat(subtotal[field_value])
                                                        sub_detail.push("")
                                                        sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                    }
                                                } else {
                                                    if (this.$attrs.friendlyCode == 'RECADJ'){
                                                        grandTotalQuantity += parseFloat(subtotal['quantity'])
                                                        grandTotalSRP += parseFloat(subtotal['subtotal'])
                                                    } else {
                                                        grandTotal += parseFloat(subtotal[field_value])
                                                    }
                                                    sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                }

                                            }
                                        }   
                                    }

                                    reportData.push(Object.assign({}, sub_detail))

                                    subtotal = {}

                                    doc.autoTable({
                                        head: [dynamic_line],
                                        body: reportData, 
                                        margin: {left: 30},
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: lineColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[3] == 'Sub Total'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                }
                            }
                        }

                        // GRAND TOTAL SHOULD BE HERE
                        let tableBody
                        let lessMargin = 0

                        if (this.$attrs.friendlyCode == 'RECADJ'){
                            tableBody = [
                                ['GRAND TOTAL', `${this.convertToCurrency(grandTotalQuantity)}`,`${this.convertToCurrency(grandTotalSRP)}`],
                            ]

                            lessMargin = 35
                        } else {
                            tableBody = [
                                ['GRAND TOTAL', `${this.convertToCurrency(grandTotal)}`],
                            ]
                        }
                      
                        // Conditionally add the grand totals row only for 'sales_order_journal'
                        if (this.currentProfile === 'sales_order_journals' || this.currentProfile === "sales_invoice_journals") {
                            lessMargin = 50
                            tableBody = [
                                ['GRAND TOTAL', 
                                `${this.convertToCurrency(grandTotalQuantity)}`, 
                                '', 
                                `${this.convertToCurrency(grandTotalNetSubtotal)}`]
                            ];
                        }
                        doc.autoTable({
                            // head: [['', '']],
                            body: tableBody,
                            margin: {left: 220 - lessMargin},
                            theme: 'plain',
                            tableWidth: 'wrap',
                            styles: {
                                cellPadding: 1.0, fontSize: 12, fontStyle: "bold",
                                halign: 'right', lineWidth: 0.15
                            },
                            columnStyles: lineColStyles,
                        })
                    }

                    // console.log("~~~~");
                    // console.log(grandTotal);

                    // doc.text(footer_x - 10,footer_y - 10,`${grandTotal}`)
                    // doc.text(footer_x - 10,footer_y - 10, [grandTotal], "right")


                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        doc.text(footer_x,footer_y,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    }

                    //doc.save(`${this.$attrs.friendlyCode}_Journal_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                console.log(this.currentProfile)
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let grandTotal = 0;
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from":  this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to":  this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "type": this.$attrs.friendlyCode,
                    "status": this.inputStatus,
                    "order_status": this.inputOrderStatus
                }

                // var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null);
                parameters.current_profile = this.currentProfile
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?',parameters, null);

                // console.log(">> Get Request")
                // console.log(get_request)

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks", "brand_name", "company_name"]

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let trans_friendly_code = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).friendly_code

                    let header_prefix = trans_friendly_code
                    let origin_prefix = 'Origin Doc'
                    let party = 'Party'

                    if(header_prefix == 'RR'){
                        origin_prefix = 'ASN'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'ASN'){
                        origin_prefix = 'PO'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'PO'){
                        origin_prefix = 'PR'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'PRT'){
                        origin_prefix = 'RR'
                        party = 'Supplier'
                    }

                    if (this.currentProfile === 'delivery_document_journals') {
                        this.checkedHeaderFields = [
                            ...this.checkedHeaderFields,   
                            "company_name",                // SBU
                            "amount_net",                  // Amount
                            "discount",                    // Discount
                            "b2b_customer_name",           // Customer
                            "customer_type"                // Customer Type
                        ];

                        this.checkedDetailFields = [
                            ...this.checkedDetailFields,   
                            "price",
                            "subtotal"   
                        ];

                        const index = this.checkedDetailFields.indexOf('barcode');
                        if (index !== -1) {
                            this.checkedDetailFields = [
                                ...this.checkedDetailFields.slice(0, index + 1), 
                                'brand_name',
                                ...this.checkedDetailFields.slice(index + 1),
                            ];
                        }
                    }

                    let field_count = this.checkedHeaderFields.length
                    let header_count = this.checkedHeaderFields.length
                    let line_count = this.checkedDetailFields.length
                    if(field_count < line_count){
                        field_count = line_count
                    }
                    let site_specific = []
                    let dynamic_header = []
                    for(let v=0; v < this.checkedHeaderFields.length; v++){
                        if(this.checkedHeaderFields[v] == 'document_no'){
                            dynamic_header.push(`${header_prefix} #`)
                        } else if(this.checkedHeaderFields[v] == 'party_name'){
                            dynamic_header.push('Party')
                        } else if(this.checkedHeaderFields[v] == 'document_date'){
                            dynamic_header.push(`${header_prefix} Date`)
                        } else if(this.checkedHeaderFields[v] == 'posted_at'){
                            dynamic_header.push(`${header_prefix} Post Date`)
                        } else if(this.checkedHeaderFields[v] == 'origin_document_no'){
                            dynamic_header.push(`${origin_prefix} #`)
                        } else if(this.checkedHeaderFields[v] == 'origin_document_date'){
                            dynamic_header.push(`${origin_prefix} Date`)
                        } else if(this.checkedHeaderFields[v] == 'company_name'){
                            dynamic_header.push('SBU')
                        } else if(this.checkedHeaderFields[v] == 'amount_net'){
                            dynamic_header.push('Amount')
                        } else if(this.checkedHeaderFields[v] == 'b2b_customer_name'){
                            dynamic_header.push('Customer')
                        } else if(this.checkedHeaderFields[v] == 'customer_type'){
                            dynamic_header.push('Customer Type')
                        } else {
                            let s = this.checkedHeaderFields[v]
                            let format_header = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_header.push(format_header)
                        } 
                    }
                    // dynamic_header.push(format_header)
                    
                    let dynamic_line = []
                    for(let v=0; v < this.checkedDetailFields.length; v++){
                        if(this.checkedDetailFields[v] == 'stock_no'){
                            dynamic_line.push('Stock No.')
                        } else if(this.checkedDetailFields[v] == 'product_name'){
                            dynamic_line.push('Description')
                        } else if(this.checkedDetailFields[v] == 'brand_name'){
                            dynamic_line.push('Brand')
                        } else if(this.checkedDetailFields[v] == 'company_name'){
                            dynamic_line.push('Company')
                        } else {
                            let s = this.checkedDetailFields[v]
                            let format_detail = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_line.push(format_detail)
                        } 
                    }
                    //dynamic_line.push(format_detail)

                    let headerData = []
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''
                        let reportData = []
                        if(this.birSalesReports.length > 0){
                            let subtotal = {}
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]


                                let header_detail = []
                                let line_detail = []

                                if(grouper == ''){
                                    
                                    for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                        let field_value = this.checkedHeaderFields[vd]
                                        
                                        if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                            field_value = `document_${field_value}`
                                        }

                                        if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                            if(reportLine[field_value] == null){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                            }
                                        } else if (field_value == 'origin_document_no'){
                                            if(reportLine[field_value] == -1){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push(reportLine[field_value])
                                            }
                                        } else if (field_value == 'document_status'){
                                            if(reportLine[field_value] == 'A'){
                                                header_detail.push('Active')
                                            } else {
                                                let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                header_detail.push(status_val)
                                            }
                                        } else {
                                            if(reportLine[field_value] == null){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push(reportLine[field_value])
                                            }
                                        } 
                                    }
                                    reportData.push(dynamic_header)
                                    reportData.push(header_detail)
                                    reportData.push(dynamic_line)
                                } else {
                                    
                                    if(grouper != reportLine.document_id){
                                        //if new document display prev dostartcument details 

                                        let sub_detail = []
                                        for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                            let field_value = this.checkedDetailFields[vd]
                                            if(field_value == 'product_name'){
                                                sub_detail.push("Sub Total")
                                            } else {
                                                if(subtotal[field_value] == undefined){
                                                    sub_detail.push('')
                                                } else {
                                                    grandTotal += parseFloat(subtotal[field_value])
                                                    sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                }
                                            }   
                                        }

                                        reportData.push(Object.assign({}, sub_detail))
                                        reportData.push(Object.assign({}, {}))
                                        reportData.push(Object.assign({}, {}))

                                        subtotal = {}

                                        for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                            let field_value = this.checkedHeaderFields[vd]
                                            
                                            if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                field_value = `document_${field_value}`
                                            }

                                            if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                                }
                                            } else if (field_value == 'origin_document_no'){
                                                if(reportLine[field_value] == -1){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            } else if (field_value == 'document_status'){
                                                if(reportLine[field_value] == 'A'){
                                                    header_detail.push('Active')
                                                } else {
                                                    let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                    header_detail.push(status_val)
                                                }
                                            } else {
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            } 
                                        }
                                        reportData.push(dynamic_header)
                                        reportData.push(header_detail)
                                        reportData.push(dynamic_line)
                                    }
                                }
                                
                                grouper = reportLine.document_id

                                for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                    let field_value = this.checkedDetailFields[vd]

                                    if(reportLine[field_value] == null){
                                        line_detail.push('')
                                    } else {
                                        // console.log(field_value, reportLine[field_value], typeof(reportLine[field_value]))
                                        let align = 'left'
                                        let convert_me = false
                                        if(no_subtotal.includes(field_value)){
                                            //dont total
                                        } else {
                                            if (typeof(reportLine[field_value]) == "string"){
                                                // console.log(parseFloat(reportLine[field_value]))
                                                // console.log(_.isNaN(parseFloat(reportLine[field_value])))
                                                if(_.isNaN(parseFloat(reportLine[field_value])) == false){
                                                    // console.log(subtotal[field_value])
                                                    if(subtotal[field_value] == undefined){
                                                        subtotal[field_value] = Number(reportLine[field_value])
                                                    } else {
                                                        subtotal[field_value] = subtotal[field_value] + Number(reportLine[field_value])
                                                    }

                                                    align = 'right'
                                                    convert_me = true
                                                }
                                                // console.log(subtotal)
                                            }
                                        }

                                        if(convert_me == true){
                                            line_detail.push(this.convertToCurrency(Number(reportLine[field_value])))
                                        } else {
                                            line_detail.push(reportLine[field_value])
                                        }
                                    }
                                }
 
                                // if(i==0){
                                //     reportData.push(dynamic_line)
                                // }
                                
                                reportData.push(line_detail)

                                if(i == this.birSalesReports.length-1){

                                    let sub_detail = []
                                    for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                        let field_value = this.checkedDetailFields[vd]
                                        if(field_value == 'product_name'){
                                            sub_detail.push("Sub Total")
                                        } else {
                                            if(subtotal[field_value] == undefined){
                                                sub_detail.push('')
                                            } else {
                                                grandTotal += parseFloat(subtotal[field_value])
                                                sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                            }
                                        }   
                                    }
 
                                    reportData.push(Object.assign({}, sub_detail))

                                    subtotal = {}
                                }
                            }
                            
                        }
 
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        var GrandTotal = [" "," "," "," ", "Grand Total:",grandTotal]
                        reportData.push(GrandTotal)
                        if(x === siteSpecific.length - 1) {
                            reportData.push([`${trans_val} Journal`, "Generate By: " + printed_by,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A')])
                        }
                        let keys = dynamic_header;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                        // this.JsonData = site_specific;
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
            generateFlatFile: async function() {
                if (this.currentProfile === 'sales_order_journals' || this.currentProfile === 'sales_invoice_journals' || this.currentProfile === 'delivery_document_journals'){
                    await this.generateForSOSIDDFlatFile()
                } else {
                    await this.generateFlatFileAll()
                }    
            },
            generateFlatFileAll: async function() {
                // console.log("CHECKPOINT: generateFlatFileAll ", this.checkedDetailFields)
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let grandTotal = 0;
                let grandTotalQuantity = 0;
                let grandTotalSRP = 0;
                let brands = "";
                let order_status = "";
                let processedDocs = new Set();

                if(['sales_order_journals','price_work_sheet_journals'].includes(this.currentProfile)){
                    // group = this.inputGroup;
                    brands = this.inputBrands.join(",");
                }

                order_status = this.inputOrderStatus.join(",");

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from":  this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to":  this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "type": this.$attrs.friendlyCode,
                    "status": this.inputStatus,
                    "order_status": order_status,
                    "brands": brands,
                    "order_source": this.inputOrderSource
                }

                // var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null);
                parameters.current_profile = this.currentProfile
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?',parameters, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks", "brand_name", "company_name"]

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let trans_friendly_code = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).friendly_code

                    let header_prefix = trans_friendly_code
                    let origin_prefix = 'Origin Doc'
                    let party = 'Party'

                    if(header_prefix == 'RR'){
                        origin_prefix = 'ASN'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'ASN'){
                        origin_prefix = 'PO'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'PO'){
                        origin_prefix = 'PR'
                        party = 'Supplier'
                    }
                    if(header_prefix == 'PRT'){
                        origin_prefix = 'RR'
                        party = 'Supplier'
                    }
                    if (this.$attrs.friendlyCode == 'RECDEL' || this.$attrs.friendlyCode == 'RECADJ'){
                        this.checkedDetailFields = this.checkedDetailFields.filter(field => field !== "stock_no");
                    }
                    if (this.$attrs.friendlyCode == 'RECADJ'){
                        this.checkedHeaderFields = [
                                "order_source",
                                ...this.checkedHeaderFields,
                                "cas_no",
                                "purpose",
                                "reference",
                                "remarks"
                            ];

                        this.checkedDetailFields = [
                                ...this.checkedDetailFields,
                                "subtotal",
                            ];

                        this.checkedHeaderFields = this.checkedHeaderFields.filter(field => field !== "origin_document_no");
                        this.checkedHeaderFields = this.checkedHeaderFields.filter(field => field !== "origin_document_date");
                        this.checkedHeaderFields = this.checkedHeaderFields.map(field => field === "party_name" ? "site_name" : field);
                        this.checkedDetailFields = [...new Set(this.checkedDetailFields)]
                    }

                    if (this.$attrs.friendlyCode == 'RELSLO'){
                        console.log("CHECKPOINT 2 RELSLO: sublocation_transfer_out_journals")
                        this.checkedDetailFields = this.checkedDetailFields.filter(field => field !== "origin_document_no");
                        this.checkedHeaderFields = this.checkedHeaderFields.filter(field => field !== "origin_document_no");
                        this.checkedHeaderFields = this.checkedHeaderFields.filter(field => field !== "origin_document_date");
                        console.log("CHECKPOINT 3 RELSLO: ", this.checkedDetailFields)
                        console.log("CHECKPOINT 4 RELSLO: ", this.checkedHeaderFields)
                    }

                    let field_count = this.checkedHeaderFields.length
                    let header_count = this.checkedHeaderFields.length
                    let line_count = this.checkedDetailFields.length
                    if(field_count < line_count){
                        field_count = line_count
                    }
                    let site_specific = []
                    let dynamic_header = []
                    let dynamic_h = []
                    for(let v=0; v < this.checkedHeaderFields.length; v++){
                        if(this.checkedHeaderFields[v] == 'document_no'){
                            dynamic_h.push(`${header_prefix} #`)
                        } else if(this.checkedHeaderFields[v] == 'party_name'){
                            dynamic_h.push('Party')
                        } else if(this.checkedHeaderFields[v] == 'document_date'){
                            dynamic_h.push(`${header_prefix} Date`)
                        } else if(this.checkedHeaderFields[v] == 'posted_at'){
                            dynamic_h.push(`${header_prefix} Post Date`)
                        } else if(this.checkedHeaderFields[v] == 'origin_document_no'){
                            if( this.currentProfile == 'price_work_sheet_journals'){
                            } else {
                                dynamic_h.push(`${header_prefix} Origin Document No`)
                            }
                        } else if(this.checkedHeaderFields[v] == 'origin_document_date'){
                            if( this.currentProfile == 'price_work_sheet_journals'){
                            } else {
                                dynamic_h.push(`${header_prefix} Origin Document Date`)                      
                            }
                        } else if(this.checkedHeaderFields[v] == 'site_name'){
                            dynamic_h.push('Target Branch')
                        } else if(this.checkedHeaderFields[v] == 'cas_no'){
                            dynamic_h.push('Cas Series #')
                        } else if(this.checkedHeaderFields[v] == 'order_source'){
                            dynamic_h.push('Order Source')
                        } else {
                            let s = this.checkedHeaderFields[v]
                            let format_header = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_h.push(format_header)
                        } 
                    }

                    let dynamic_l = []
                    if (this.currentProfile == 'price_work_sheet_journals'){
                        this.checkedDetailFields = [
                            "barcode",
                            "description",
                            "retail_price",
                            "old_retail_price",
                            "original_cost",
                            "old_original_cost",
                            "landed_cost",
                            "old_landed_cost",
                            "ordering_cost",
                            "old_ordering_cost",
                            "special_price",
                            "old_special_price",
                            "wholesale_price",
                            "old_wholesale_price",
                            "least_price",
                            "old_least_price",
                        ]
                    } else if (this.currentProfile == 'sublocation_transfer_out_journals'){
                        console.log("sublocation_transfer_out_journals")
                        this.checkedDetailFields = [
                            "barcode",
                            "product_name",
                            "quantity",
                            'site_name',
                            'sublocation_from',
                            'sublocation_to',
                        ]
                        console.log("checkpoint this.checkedDetailFields: ", this.checkedDetailFields)
                        console.log("checkpoint this.checkedHeaderFields: ", this.checkedHeaderFields)
                    } 
                    for(let v=0; v < this.checkedDetailFields.length; v++){
                        if(this.checkedDetailFields[v] == 'product_name'){
                            dynamic_l.push('Description')
                        }else if(this.checkedDetailFields[v] == 'brand_name'){
                            dynamic_l.push('Brand')
                        }else if(this.checkedDetailFields[v] == 'company_name'){
                            dynamic_l.push('Company')
                        }else if(this.checkedDetailFields[v] == 'stock_no'){
                            dynamic_l.push('Stock No')
                        }else if(this.checkedDetailFields[v] == 'subtotal'){
                            dynamic_l.push('Total SRP')
                        }else {
                            let s = this.checkedDetailFields[v]
                            let format_detail = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_l.push(format_detail)
                        } 
                    }
                  
                    dynamic_header = [...dynamic_h,...dynamic_l]
                    let headerData = []
                    let reportData = []
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''
                        if(this.birSalesReports.length > 0){
                            let subtotal = {}
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let header_detail = []
                                let line_detail = []

                                if(grouper == ''){
                                    for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                        let field_value = this.checkedHeaderFields[vd]
                                        
                                        if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                            field_value = `document_${field_value}`
                                        }

                                        if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                            if (field_value == 'origin_document_date' && this.currentProfile == 'price_work_sheet_journals'){

                                            }else {
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                                }
                                            }
                                        } else if (field_value == 'origin_document_no'){
                                            if (field_value == 'origin_document_no' && this.currentProfile == 'price_work_sheet_journals'){

                                            }else {
                                                if(reportLine[field_value] == -1){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            }
                                        } else if (field_value == 'document_status'){
                                            if(reportLine[field_value] == 'A'){
                                                header_detail.push('Active')
                                            } else {
                                                let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                header_detail.push(status_val)
                                            }
                                        } else {
                                            if(reportLine[field_value] == null){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push(reportLine[field_value])
                                            }
                                        } 
                                    }
                                } else {
                                    
                                    if(grouper != reportLine.document_id){
                                        //if new document display prev dostartcument details 

                                        let sub_detail = []
                                        for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                            let field_value = this.checkedDetailFields[vd]
                                            if(field_value == 'product_name'){
                                                // sub_detail.push("Sub Total")
                                            } else {
                                                if(subtotal[field_value] == undefined){
                                                    // sub_detail.push('')
                                                } else {
                                                    if (this.$attrs.friendlyCode == 'RECADJ'){
                                                        if (!processedDocs.has(grouper)) { // Only add if not processed
                                                            if (field_value === 'quantity') {
                                                                grandTotalQuantity += parseFloat(subtotal['quantity']);
                                                            }
                                                            if (field_value === 'subtotal') {
                                                                grandTotalSRP += parseFloat(subtotal['subtotal']);
                                                            }
                                                        }
                                                    } else {
                                                        grandTotal += parseFloat(subtotal[field_value])
                                                    }
                                                }
                                            }   
                                        }

                                        subtotal = {}
                                    }
                                    for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                            let field_value = this.checkedHeaderFields[vd]
                                            
                                            if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                field_value = `document_${field_value}`
                                            }

                                            if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                if (field_value == 'origin_document_date' && this.currentProfile == 'price_work_sheet_journals'){

                                                }else {
                                                    if(reportLine[field_value] == null){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                                    }
                                                }
                                            } else if (field_value == 'origin_document_no'){
                                                if (field_value == 'origin_document_no' && this.currentProfile == 'price_work_sheet_journals'){

                                                }else {
                                                    if(reportLine[field_value] == -1){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push(reportLine[field_value])
                                                    }
                                                }
                                            } else if (field_value == 'document_status'){
                                                if(reportLine[field_value] == 'A'){
                                                    header_detail.push('Active')
                                                } else {
                                                    let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                    header_detail.push(status_val)
                                                }
                                            } else {
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            } 
                                        }
                                }
                                
                                grouper = reportLine.document_id

                                for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                    let field_value = this.checkedDetailFields[vd]
                                    if(reportLine[field_value] == null){
                                        line_detail.push('')
                                    } else {
                                        let align = 'left'
                                        let convert_me = false
                                        if(no_subtotal.includes(field_value)){
                                            //dont total
                                        } else {
                                            if (typeof(reportLine[field_value]) == "string"){
                                                // console.log(parseFloat(reportLine[field_value]))
                                                // console.log(_.isNaN(parseFloat(reportLine[field_value])))
                                                if(_.isNaN(parseFloat(reportLine[field_value])) == false){
                                                    // console.log(subtotal[field_value])
                                                    if(subtotal[field_value] == undefined){
                                                        subtotal[field_value] = Number(reportLine[field_value])
                                                    } else {
                                                        subtotal[field_value] = subtotal[field_value] + Number(reportLine[field_value])
                                                    }

                                                    align = 'right'
                                                    convert_me = true
                                                }
                                            }
                                        }

                                        if(convert_me == true){
                                            line_detail.push(this.convertToCurrency(Number(reportLine[field_value])))
                                        } else {
                                            line_detail.push(reportLine[field_value])
                                        }
                                    }
                                }
                                // reportData.push(dynamic_line)
                                const combinedFields = [...header_detail, ...line_detail];
                                if (combinedFields.length<dynamic_header.length){
                                    var space = []
                                    for(let i=0; i < dynamic_h.length; i++){
                                        space.push('')
                                    }
                                    combinedFields = [...space,...combinedFields]
                                }
                                // console.log(combinedFields)
                                reportData.push(combinedFields)

                                if(i == this.birSalesReports.length-1){

                                    let sub_detail = []
                                    for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                        let field_value = this.checkedDetailFields[vd]
                                        if(field_value == 'product_name'){
                                            sub_detail.push("Sub Total")
                                        } else {
                                            if(subtotal[field_value] == undefined){
                                                sub_detail.push('')
                                            } else {
                                                if (this.$attrs.friendlyCode == 'RECADJ'){
                                                    if (!processedDocs.has(grouper)) { // Only add if not processed
                                                        if (field_value === 'quantity') {
                                                            grandTotalQuantity += parseFloat(subtotal['quantity']);
                                                        }
                                                        if (field_value === 'subtotal') {
                                                            grandTotalSRP += parseFloat(subtotal['subtotal']);
                                                        }
                                                    }
                                                } else {
                                                    grandTotal += parseFloat(subtotal[field_value])
                                                }
                                            }
                                        }   
                                    }

                                    subtotal = {}
                                }
                            }
                            
                        }

                        
                        
                    }
                    let printed_by = secureStorage.getItem("email")

                    if(printed_by == null){
                        printed_by = ''
                    }

                    if (this.currentProfile == 'sublocation_transfer_out_journals'){
                        var space = []
                        for(let i=0; i < dynamic_h.length; i++){
                            space.push('')
                        }
                        let GrandTotal

                        if (this.$attrs.friendlyCode == 'RECADJ'){
                            GrandTotal = [" "," "," ","Grand Total:", grandTotalQuantity,parseFloat(grandTotalSRP).toFixed(2)]
                        } else {
                            GrandTotal = [" ","Grand Total:",grandTotal]
                        }
                        GrandTotal = [...space,...GrandTotal]
                        reportData.push(GrandTotal)
                    } else if (this.currentProfile != 'price_work_sheet_journals'){
                        var space = []
                        for(let i=0; i < dynamic_h.length; i++){
                            space.push('')
                        }
                        var GrandTotal
                        if (this.$attrs.friendlyCode == 'RECDEL' || this.$attrs.friendlyCode == 'RECADJ'){
                            if (this.$attrs.friendlyCode == 'RECADJ'){
                                GrandTotal = [" "," "," ","Grand Total:",grandTotalQuantity,grandTotalSRP]
                            } else {
                                GrandTotal = [" ","Grand Total:",grandTotal]
                            }
                        } else {
                            GrandTotal = [" "," ","Grand Total:",grandTotal]
                        }
                        GrandTotal = [...space,...GrandTotal]
                        reportData.push(GrandTotal)
                    }

                    reportData.push([`${trans_val} Journal`, "Generate By: " + printed_by,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A')])
                    let keys = dynamic_header;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }
                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                        if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                        }
                        }
                    });
                    site_specific.push(newJsonData)
                        // this.JsonData = site_specific;
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
            generateForSOSIDDFlatFile: async function() {
                // try {
                    this.spinning = true;

                    let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                    let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                    // Early validation
                    if (this.inputDate.length === 0) {
                        this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                        return;
                    }
                    let companies = "";
                    let brands = "";
                    let customers = "";
                    let order_status = "";
                    if(['sales_order_journals'].includes(this.currentProfile)){
                        // group = this.inputGroup;
                        brands = this.inputBrands.join(",");
                        customers = this.inputCustomers.join(",");
                        
                    }
                    var is_exclude = true
                    if(this.currentProfile == 'sales_invoice_journals'){
                        // group = this.inputGroup;
                        companies = this.inputCompanies.join(",");
                        is_exclude = false
                    }
                    order_status = this.inputOrderStatus.join(",");
                    // Build request parameters
                    const parameters = {
                        site_id: this.inputSite.toString(),
                        date_from: this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                        date_to: this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                        order: this.inputSortBy,
                        by: this.showSortInfo,
                        type: this.$attrs.friendlyCode,
                        status: this.inputStatus,
                        order_status: order_status,
                        companies: companies,
                        brands: brands,
                        customers: customers,
                    };
                    if (this.inputFormat == 3 || this.inputFormat == "3") {
                        parameters.input_format = this.inputFormat;
                    }
                    parameters.current_profile = this.currentProfile
                    var response = ""
                    var response1 = ""
                    // Get data
                    if((this.inputFormat == 2 || this.inputFormat == "2") || (this.inputFormat == 3 || this.inputFormat == "3")){
                        parameters.is_exclude = is_exclude;
                        response = await HTTPRequest.getRequest(this.endPoint + 'operation_report_summary?', parameters, null);
                        parameters.type = "RELPOS"
                        parameters.is_manual = true
                        response1 = await HTTPRequest.getRequest(this.endPoint + 'pos_operation_report_summary?', parameters, null);
                        if (!response.length && !response1.length) {
                            this.openNotificationWithIcon('error', 'No Data.');
                            this.spinning = false;
                            return;
                        }
                    } else {
                        response = await HTTPRequest.getRequest(this.endPoint + 'operation_report?', parameters, null);
                        if (!response.length) {
                            this.openNotificationWithIcon('error', 'No Data.');
                            this.spinning = false;
                            return;
                        }
                    }
                    
                    if(this.inputFormat == 2 || this.inputFormat == "2"){
                        var siteSpecific = response;
                        var siteSpecific1 = response1;
                        let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                        let site_specific = [];
                        let new_temp_details = []
                        // let headers = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' ', ' ', ' ', ' ', ' ', ' ', ' '];
                        let headers = [' Detail',' FIXED',' Tin',' Registered Name',' Last Name',' First Name',' Middle Name',' Trade Name',' Substreet Street Barangay Municipality City ZipCpde',' Exempt', ' Zero Rated', ' Vatable', ' VAT', ' RDO', ' End of Month', ' Date'];
                        let group_text = ""
                        if(this.inputSortBy != ''){
                            group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                        }
                        for(let x=0; x < siteSpecific.length; x++){
                            let birSalesReports = siteSpecific[x].report_details
                            if(birSalesReports.length > 0){
                                let grouper = 'start'
                                let temp_detail = []
                                for(let i=0; i < birSalesReports.length; i++){
                                    let reportLine = birSalesReports[i]
                                    let amount_net_non_vat = 0
                                    let amount_net_zero_rated = 0
                                    let amount_net_of_vat = 0
                                    let amount_tax = 0
                                    grouper = reportLine.company_name
                                    if(reportLine.party_tax_type == "V"){
                                        amount_net_of_vat = reportLine.amount_net - reportLine.tax_amount
                                        amount_tax = reportLine.tax_amount
                                    }else if(reportLine.party_tax_type == "Z"){
                                        amount_net_zero_rated = reportLine.amount_net
                                    }else if(reportLine.party_tax_type == "X"){
                                        amount_net_non_vat = reportLine.amount_net
                                    }

                                    var name = (String(reportLine.customer_name).includes(String(decrypt(reportLine.customer_lname))) && decrypt(reportLine.customer_lname)!="" && decrypt(reportLine.customer_lname)!=null && decrypt(reportLine.customer_fname)!="" && decrypt(reportLine.customer_fname)!=null) ? "" : String(reportLine.customer_name)
                                    if (reportLine.document_type_code == "SIN"){
                                        temp_detail.push(
                                            {
                                                customer_tin:String(decrypt(reportLine.customer_tin)),
                                                name:name,
                                                customer_lname:String(decrypt(reportLine.customer_lname)),
                                                customer_fname:String(decrypt(reportLine.customer_fname)),
                                                customer_mname:String(decrypt(reportLine.customer_mname)),
                                                customer_address:String(reportLine.customer_address),
                                                amount_net_non_vat:Number(amount_net_non_vat),
                                                amount_net_zero_rated:Number(amount_net_zero_rated),
                                                amount_net_of_vat:Number(amount_net_of_vat),
                                                amount_tax:Number(amount_tax),
                                            }
                                        )
                                    }else{
                                        temp_detail.push(
                                            {
                                                customer_tin:String(decrypt(reportLine.customer_tin)),
                                                name:name,
                                                customer_lname:String(decrypt(reportLine.customer_lname)),
                                                customer_fname:String(decrypt(reportLine.customer_fname)),
                                                customer_mname:"",
                                                customer_address:String(reportLine.customer_address),
                                                amount_net_non_vat:(Number(amount_net_non_vat)*-1),
                                                amount_net_zero_rated:(Number(amount_net_zero_rated)*-1),
                                                amount_net_of_vat:(Number(amount_net_of_vat)*-1),
                                                amount_tax:(Number(amount_tax)*-1),
                                            }
                                        )
                                    }
                                    if(grouper != reportLine.company_name || i == (birSalesReports.length-1)){
                                        var index = new_temp_details.findIndex(x => x.company_name == reportLine.company_name);
                                        if (index < 0){
                                            new_temp_details.push(
                                            {
                                                company_tin:reportLine.company_tin,
                                                company_name:reportLine.company_name,
                                                company_address:reportLine.company_address,
                                                details:temp_detail
                                            })
                                        }else{
                                            new_temp_details[index].details = [...new_temp_details[index].details,...temp_detail]
                                        }
                                        temp_detail = []
                                    }
                                }
                            }
                        }
                        for(let x=0; x < siteSpecific1.length; x++){
                            let birSalesReports = siteSpecific1[x].report_details
                            if(birSalesReports.length > 0){
                                let grouper = 'start'
                                let temp_detail = []
                                for(let i=0; i < birSalesReports.length; i++){
                                    let reportLine = birSalesReports[i]
                                    grouper = reportLine.company_code
                                    if (reportLine.status != "R" && reportLine.status != "V"){
                                        temp_detail.push(
                                            {
                                                customer_tin:String(decrypt(reportLine.customer_tin)),
                                                name:String(reportLine.customer_name),
                                                customer_lname:'',
                                                customer_fname:'',
                                                customer_mname:'',
                                                customer_address:String(reportLine.customer_address),
                                                amount_net_non_vat:Number(reportLine.amount_net_non_vat),
                                                amount_net_zero_rated:Number(reportLine.amount_net_zero_rated),
                                                amount_net_of_vat:Number(reportLine.amount_net_of_vat),
                                                amount_tax:Number(reportLine.amount_tax),
                                            }
                                        )
                                    }else{
                                        temp_detail.push(
                                            {
                                                customer_tin:String(decrypt(reportLine.customer_tin)),
                                                name:String(reportLine.customer_name),
                                                customer_lname:'',
                                                customer_fname:'',
                                                customer_mname:'',
                                                customer_address:String(reportLine.customer_address),
                                                amount_net_non_vat:Number(reportLine.amount_net_non_vat)*-1,
                                                amount_net_zero_rated:Number(reportLine.amount_net_zero_rated)*-1,
                                                amount_net_of_vat:Number(reportLine.amount_net_of_vat)*-1,
                                                amount_tax:Number(reportLine.amount_tax)*-1,
                                            }
                                        )
                                    }
                                    if(grouper != reportLine.company_code || i == (birSalesReports.length-1)){
                                        var index = new_temp_details.findIndex(x => x.company_name == reportLine.company_name);
                                        if (index < 0){
                                            new_temp_details.push(
                                                {
                                                    company_tin:reportLine.company_tin,
                                                    company_name:reportLine.company_name,
                                                    company_address:reportLine.company_address,
                                                    details:temp_detail
                                                })
                                        }else{
                                            new_temp_details[index].details = [...new_temp_details[index].details,...temp_detail]
                                        }
                                        temp_detail = []
                                    }
                                }
                            }
                        }
                        console.log(new_temp_details)
                        if(new_temp_details.length > 0){
                            let grand_total_amount = 0
                            let total_amount_net_non_vat = 0
                            let total_amount_net_zero_rated = 0
                            let total_amount_net_of_vat = 0
                            let total_amount_tax = 0
                            let company_tin = ""
                            let company_code = ""
                            let company_name = ""
                            let company_address = ""
                            let temp_detail = []
                            let reportData = []
                            for(let i=0; i < new_temp_details.length; i++){
                                let reportLine = new_temp_details[i]
                                for(let y=0; y < reportLine.details.length; y++){
                                    let yline = reportLine.details[y]
                                    let detail = ["D","S",
                                        yline.customer_tin,
                                        String(yline.name).includes(',') ? '"' + yline.name +'"' : yline.name,
                                        String(yline.customer_lname).includes(',') ? '"' + yline.customer_lname + '"' : yline.customer_lname,
                                        String(yline.customer_fname).includes(',') ? '"' + yline.customer_fname + '"' : yline.customer_fname,
                                        String(yline.customer_mname).includes(',') ? '"' + yline.customer_mname + '"' : yline.customer_mname,
                                        String(yline.customer_address).includes(',') ? '"' + yline.customer_address + '"' : yline.customer_address,
                                        "",
                                        Number(yline.amount_net_non_vat).toFixed(2),
                                        Number(yline.amount_net_zero_rated).toFixed(2),
                                        Number(yline.amount_net_of_vat).toFixed(2),
                                        Number(yline.amount_tax).toFixed(2),
                                        reportLine.company_tin,
                                        this.inputDate[1].format('MM/DD/YYYY'),
                                    ]
                                    temp_detail.push(Object.assign({}, detail))
                                    //amount_due += Number(reportLine.amount_due)
                                    total_amount_net_non_vat += Number(yline.amount_net_non_vat)
                                    total_amount_net_zero_rated += Number(yline.amount_net_zero_rated)
                                    //amount_net += Number(reportLine.amount_net)
                                    total_amount_net_of_vat += Number(yline.amount_net_of_vat)
                                    total_amount_tax += Number(yline.amount_tax)

                                    if(y == (reportLine.details.length-1)){
                                        let company_header = ["H","S",
                                            reportLine.company_tin,
                                            String(reportLine.company_name).includes(',') ? '"' + String(reportLine.company_name) + '"' : String(reportLine.company_name),
                                            "",
                                            "",
                                            "",
                                            String(reportLine.company_name).includes(',') ? '"' + String(reportLine.company_name) + '"' : String(reportLine.company_name),
                                            String(reportLine.company_address).includes(',') ? '"' + String(reportLine.company_address) + '"' : String(reportLine.company_address),
                                            "",
                                            total_amount_net_non_vat.toFixed(2),
                                            total_amount_net_zero_rated.toFixed(2),
                                            total_amount_net_of_vat.toFixed(2),
                                            total_amount_tax.toFixed(2),
                                            this.rdoField || "",
                                            this.inputDate[1].format('MM/DD/YYYY'),
                                            this.quarterField || ""
                                        ];
                                        reportData.push(Object.assign({}, company_header))
                                        
                                        reportData = [...reportData,...temp_detail]
                                        total_amount_net_non_vat = 0
                                        total_amount_net_zero_rated = 0
                                        total_amount_net_of_vat = 0
                                        total_amount_tax = 0
                                        temp_detail = []
                                    }
                                }
                                company_tin = reportLine.company_tin
                                company_code = reportLine.company_code
                                company_name = reportLine.company_name
                                company_address = reportLine.company_address

                                let printed_by = secureStorage.getItem("email")
                                if(printed_by == null){
                                    printed_by = ''
                                }
                                reportData.push(Object.assign({},[]))

                                if (i == new_temp_details.length-1){
                                    reportData.push(Object.assign({},[trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date]))
                                    reportData.push(Object.assign({},[]))
                                }
                            }
                            console.log(reportData)
                            
                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;

                            let newJsonData=[];

                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                        [val]: values[i][index]
                                    }
                                )
                                )
                            );
                            newJsonData.push(result)
                            }

                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                                }
                            }
                            });
                            site_specific.push(reportData)
                        }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);

                        if (this.JsonData.length === 0) {
                            this.openNotificationWithIcon('warning', 'No data to export. Please check your filter selections.', 'Generate Report');
                        }
                    } else if(this.inputFormat == 3){
                        let siteSpecific = response;
                        let siteSpecific1 = response1;
                        let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                        let headers = [' Date',' Customer TIN',' Customer Name',' Address',' Description',' Transaction Type',' Reference/Doc No/Invoice No',' Amount',' Discount',' Net Sales', ' VAT Amount', ' Gross Sales'];
                        let site_specific = [];
                        let group_text = ""
                        let recordCount = 0
                        let total_amount_due = 0;
                        let total_amount_total_discount = 0;
                        let total_amount_net = 0;
                        let total_amount_tax = 0;
                        let total_amount_gross = 0;
                        if(this.inputSortBy != ''){
                            group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                        }
                        for(let x=0; x < siteSpecific.length; x++){
                            this.birSalesReports = siteSpecific[x].report_details
                            this.birSalesReports.sort((a, b) => {
                                const casNoA = a.cas_no ? a.cas_no.toString() : '';
                                const casNoB = b.cas_no ? b.cas_no.toString() : '';
                                return casNoA.localeCompare(casNoB);
                            });
                            let reportData = [];
                            let metadata = [
                                ['Sales Invoice Journal'],
                                [],
                                ["Taxable Year", this.inputDate[1].format('YYYY')],
                                ["Company Name", ''],  
                                ["Company Address", ''], 
                                ["TIN", ''],  
                                ["Software Name", 'Barter 5.0'],
                                ["File Name", 'fileName'],
                                ["File Type", 'fileType'],
                                ["Number of Records", ''],
                                ["Period Covered", `${this.inputDate[0].format('MMM')} ${this.inputDate[0].format('YYYY')} - ${this.inputDate[1].format('MMM')} ${this.inputDate[1].format('YYYY')}` || ''],
                                ["Run Date", this.currDate.replace('_', ' ')|| ''],
                                ["Extracted By", secureStorage.getItem("email") || ''],
                                []
                            ];
                            if(x == 0){
                                reportData.unshift(...metadata);
                                reportData.push(headers)
                            }
                            if(this.birSalesReports.length > 0){
                                let grand_total_amount = 0
                                let amount_due = 0
                                let amount_total_discount = 0
                                let amount_net = 0
                                let amount_tax = 0
                                let amount_gross = 0
                                let grouper = 'start'
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    recordCount++
                                    metadata[3][1] = reportLine.company_name || '';
                                    metadata[4][1] = reportLine.company_address || '';
                                    metadata[5][1] = reportLine.company_tin || '';
                                    // let netSales = ((Number(reportLine.amount_gross) + Number(reportLine.amount_line_discount)) / 1.12)
                                    // let amountDue = Number(reportLine.amount_gross) + Number(reportLine.amount_line_discount)
                                    let netSales = Number(reportLine.net_amount_without_tax)
                                    let amountDue = Number(reportLine.amount_gross)
                                    let detail = [
                                        moment(String(reportLine.document_date)).format('MM/DD/YYYY'),
                                        String(decrypt(reportLine.customer_tin)),
                                        String(decrypt(reportLine.customer_name)),
                                        String(reportLine.customer_address),
                                        String(''),
                                        String((reportLine.document_type_code == 'SIN') ? 'Invoice' : ((reportLine.document_type_code == 'CSR') ? 'Credit Memo': 'Aborted')),
                                        String(reportLine.cas_no || ''),
                                        // reportLine.document_type_code == 'SIN' ? Number(amountDue).toFixed(2) : -Number(amountDue).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(reportLine.amount_line_discount).toFixed(2) : -Number(reportLine.amount_line_discount).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(netSales).toFixed(2) : -Number(netSales).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(amountDue - netSales).toFixed(2) : -Number(amountDue - netSales).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(reportLine.amount_gross).toFixed(2) : -Number(reportLine.amount_gross).toFixed(2),
                                        reportLine.document_type_code == 'SIN' ? Number(reportLine.amount_gross).toFixed(2) : -Number(reportLine.amount_gross).toFixed(2),
                                        reportLine.document_type_code == 'SIN' ? (Number(reportLine.amount_line_discount) + Number(reportLine.amount_header_discount) + Number(reportLine.trade_discount)).toFixed(2) : -(Number(reportLine.amount_line_discount) + Number(reportLine.amount_header_discount) + Number(reportLine.trade_discount)).toFixed(2),
                                        reportLine.document_type_code == 'SIN' ? Number(reportLine.net_amount_without_tax).toFixed(2) : -Number(reportLine.net_amount_without_tax).toFixed(2),
                                        reportLine.document_type_code == 'SIN' ? Number(reportLine.tax_amount).toFixed(2) : -Number(reportLine.tax_amount).toFixed(2),
                                        reportLine.document_type_code == 'SIN' ? Number(reportLine.amount_net).toFixed(2) : -Number(reportLine.amount_net).toFixed(2),
                                        
                                    ]
                                    //amount_due += Number(reportLine.amount_due)
                                    if(reportLine.document_type_code == 'SIN') {
                                    
                                        amount_due += amountDue
                                        amount_total_discount +=(Number(reportLine.amount_line_discount) + Number(reportLine.amount_header_discount))
                                        amount_net += netSales
                                        amount_tax += Number(reportLine.tax_amount)
                                        amount_gross += Number(reportLine.amount_net)
                                    } else {
                                        amount_due -= amountDue
                                        amount_total_discount -= (Number(reportLine.amount_line_discount) + Number(reportLine.amount_header_discount))
                                        amount_net -= netSales
                                        amount_tax -= Number(reportLine.tax_amount)
                                        amount_gross -= Number(reportLine.amount_net)
                                    }
                                    reportData.push(Object.assign({}, detail))
                                }
                                total_amount_due += amount_due;
                                total_amount_total_discount += amount_total_discount;
                                total_amount_net += amount_net;
                                total_amount_tax += amount_tax;
                                total_amount_gross += amount_gross;

                            }

                            // let printed_by = secureStorage.getItem("email")
                            // if(printed_by == null){
                            //     printed_by = ''
                            // }
                            // if(x === siteSpecific.length - 1) {
                            //     //reportData[9][1] = String(recordCount);
                            //     reportData.push(Object.assign({}, ['Total', '', '', '', '', '', '', Number(total_amount_due).toFixed(2), Number(total_amount_total_discount).toFixed(2), Number(total_amount_net).toFixed(2), Number(total_amount_tax).toFixed(2), Number(total_amount_gross).toFixed(2)]));
                            //     reportData.push([trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date])
                            // }

                            let keys = headers.map((header, index) => index + 1);;
                            let values = reportData;
                            let values_length = values.length;

                            let newJsonData=[];

                            // change headers and report data as key and value object
                            for(let i=0;i < values_length; i++){
                                let result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                        [val]: values[i][index]
                                    }
                                )
                                )
                            );
                            newJsonData.push(result)
                            }


                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                                }
                            }
                            });
                            site_specific.push(newJsonData)
                        }
                        for(let x=0; x < siteSpecific1.length; x++){
                            let birSalesReports = siteSpecific1[x].report_details
                            birSalesReports.sort((a, b) => {
                                const casNoA = a.cas_no ? a.cas_no.toString() : '';
                                const casNoB = b.cas_no ? b.cas_no.toString() : '';
                                return casNoA.localeCompare(casNoB);
                            });
                            let reportData = [];
                            if(birSalesReports.length > 0){
                                let amount_due = 0
                                let amount_total_discount = 0
                                let amount_net = 0
                                let amount_tax = 0
                                let amount_gross = 0
                                for(let i=0; i < birSalesReports.length; i++){
                                    let reportLine = birSalesReports[i]
                                    recordCount++
                                    // let netSales = ((Number(reportLine.amount_gross) + Number(reportLine.amount_line_discount)) / 1.12)
                                    // let amountDue = Number(reportLine.amount_gross) + Number(reportLine.amount_line_discount)
                                    let netSales = Number(reportLine.amount_net)
                                    let amountDue = Number(reportLine.amount_gross)
                                    let detail = [
                                        moment(String(reportLine.document_date)).format('MM/DD/YYYY'),
                                        String(decrypt(reportLine.customer_tin)),
                                        String(decrypt(reportLine.customer_name)),
                                        String(reportLine.customer_address),
                                        String(reportLine.manual_reference_number),
                                        String((reportLine.document_type_code == 'POS') ? 'POS Transaction' : 'POS'),
                                        String(reportLine.or_doc || ''),
                                        // reportLine.document_type_code == 'SIN' ? Number(amountDue).toFixed(2) : -Number(amountDue).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(reportLine.amount_line_discount).toFixed(2) : -Number(reportLine.amount_line_discount).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(netSales).toFixed(2) : -Number(netSales).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(amountDue - netSales).toFixed(2) : -Number(amountDue - netSales).toFixed(2),
                                        // reportLine.document_type_code == 'SIN' ? Number(reportLine.amount_gross).toFixed(2) : -Number(reportLine.amount_gross).toFixed(2),
                                        Number(reportLine.amount_gross).toFixed(2),
                                        Number(reportLine.amount_total_discount).toFixed(2),
                                        ((Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount)) - Number(reportLine.amount_tax)).toFixed(2),
                                        Number(reportLine.amount_tax).toFixed(2),
                                        (Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount)).toFixed(2),
                                        
                                    ]
                                    //amount_due += Number(reportLine.amount_due)
                                    amount_due += Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount);
                                    amount_total_discount += Number(reportLine.amount_total_discount);
                                    amount_net += (Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount) - Number(reportLine.amount_tax));
                                    amount_tax += Number(reportLine.amount_tax);
                                    amount_gross += Number(reportLine.amount_gross);
                                    reportData.push(Object.assign({}, detail))
                                }
                                total_amount_due += amount_due;
                                total_amount_total_discount += amount_total_discount;
                                total_amount_net += amount_net;
                                total_amount_tax += amount_tax;
                                total_amount_gross += amount_gross;

                            }

                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
                            if(x === siteSpecific1.length -1) {
                                //reportData[9][1] = String(recordCount);
                                reportData.push(Object.assign({}, ['Total', '', '', '', '', '', '', Number(total_amount_due).toFixed(2), Number(total_amount_total_discount).toFixed(2), Number(total_amount_net).toFixed(2), Number(total_amount_tax).toFixed(2), Number(total_amount_gross).toFixed(2)]));
                                reportData.push([trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date])
                            }

                            let keys = headers.map((header, index) => index + 1);;
                            let values = reportData;
                            let values_length = values.length;

                            let newJsonData=[];

                            // change headers and report data as key and value object
                            for(let i=0;i < values_length; i++){
                                let result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                        [val]: values[i][index]
                                    }
                                )
                                )
                            );
                            newJsonData.push(result)
                            }


                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                                }
                            }
                            });
                            site_specific.push(newJsonData)
                        }

                        site_specific[0][9][2] = recordCount
                        console.log(site_specific)
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                        if (this.JsonData.length === 0) {
                            this.openNotificationWithIcon('warning', 'No data to export. Please check your filter selections.', 'Generate Report');
                        }
                    } else {
                        // Constants
                        const NO_SUBTOTAL_FIELDS = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks", "brand_name"];
                        const transactionInfo = this.transOptions.find(x => x.key === this.$attrs.friendlyCode);
                        const headerPrefix = transactionInfo.friendly_code;

                        // Determine document prefixes based on header
                        const prefixMap = {
                            'RR': { origin: 'ASN', party: 'Supplier' },
                            'ASN': { origin: 'PO', party: 'Supplier' },
                            'PO': { origin: 'PR', party: 'Supplier' },
                            'PRT': { origin: 'RR', party: 'Supplier' }
                        };
                        const { origin: originPrefix, party } = prefixMap[headerPrefix] || { origin: 'Origin Doc', party: 'Party' };
                        this.checkedHeaderFields = [
                            ...this.checkedHeaderFields,
                            "company_name",                // SBU
                            "amount_net",                  // Amount
                            "discount",                    // Discount
                            "b2b_customer_name",           // Customer
                            "customer_type"                // Customer Type
                        ];
                        if(this.currentProfile == 'sales_order_journals'){
                            this.checkedDetailFields = [
                                ...this.checkedDetailFields,
                                "price",
                                "amount_header_discount",
                                "amount_line_discount",
                                "subtotal"
                            ];
                        } else {
                            this.checkedDetailFields = [
                                ...this.checkedDetailFields,
                                "price",
                                "subtotal"
                            ];
                        }
                        if (this.$attrs.friendlyCode == 'OTHSIN') {
                            this.checkedHeaderFields = this.checkedHeaderFields.map(field => 
                                field === "party_name" ? "site_name" : field
                            );
                        }

                        const index = this.checkedDetailFields.indexOf('barcode');
                        if (index !== -1) {
                            this.checkedDetailFields = [
                                ...this.checkedDetailFields.slice(0, index + 1),
                                'brand_name',
                                ...this.checkedDetailFields.slice(index + 1),
                            ];
                        }
                        let headerMap 
                        if(this.currentProfile == 'sales_order_journals'){
                            headerMap = {
                                // Header fields
                                'document_no': `${headerPrefix} #`,
                                'party_name': 'Party',
                                'document_date': `${headerPrefix} Date`,
                                'posted_at': `${headerPrefix} Post Date`,
                                'company_name': 'SBU',
                                'amount_net': 'Amount',
                                'b2b_customer_name': 'Customer',
                                'customer_type': 'Customer Type',
                                'product_name': 'Description',
                                'brand_name': 'Brand',
                                'amount_header_discount': 'Header Discount',
                                'amount_line_discount': 'Line Discount',
                                'subtotal': 'Net Subtotal',
                            };
                        }else{
                            headerMap = {
                                // Header fields
                                'document_no': `${headerPrefix} #`,
                                'party_name': 'Party',
                                'site_name': 'Site',
                                'document_date': `${headerPrefix} Date`,
                                'posted_at': `${headerPrefix} Post Date`,
                                'origin_document_no': `${originPrefix} #`,
                                'origin_document_date': `${originPrefix} Date`,
                                'company_name': 'SBU',
                                'amount_net': 'Amount',
                                'b2b_customer_name': 'Customer',
                                'customer_type': 'Customer Type',
                                'stock_no': 'Stock No.',
                                'product_name': 'Description',
                                'brand_name': 'Brand',
                                'subtotal': 'Net Subtotal'
                            };
                        }
                        
                        for(let v=0; v < this.checkedHeaderFields.length; v++){
                            if(this.checkedHeaderFields[v] == "origin_document_no" && this.currentProfile == 'sales_order_journals'){
                                this.checkedHeaderFields.splice(v,1)
                            }
                            if (this.checkedHeaderFields[v] == "origin_document_date" && this.currentProfile == 'sales_order_journals'){
                                this.checkedHeaderFields.splice(v,1)
                            }
                            if (this.checkedHeaderFields[v] == "stock_no" && this.currentProfile == 'sales_order_journals'){
                                this.checkedHeaderFields.splice(v,1)
                            }
                        }
                        for(let v=0; v < this.checkedDetailFields.length; v++){
                            if (this.checkedDetailFields[v] == "stock_no" && this.currentProfile == 'sales_order_journals'){
                                this.checkedDetailFields.splice(v,1)
                            }
                        }
                        
                        // Combine header and detail fields
                        const combinedFields = [...this.checkedHeaderFields, ...this.checkedDetailFields];
                        const combinedHeaders = combinedFields.map(field =>
                            headerMap[field] || field.charAt(0).toUpperCase() + field.slice(1)
                        );
                        
                        let grandTotalQuantity = 0;
                        let grandTotalPrice = 0;
                        let grandTotalNetSubtotal = 0;
                        const finalData = [];
                        
                        console.log(this.checkedHeaderFields)
                        // Process each site's data
                        for (const siteData of response) {
                            let currentDocId = '';
                            let subtotals = {};

                            for (let i = 0; i < siteData.report_details.length; i++) {
                                const report = siteData.report_details[i];

                                // Check if this is the first row for the document
                                //const isFirstRow = (i === 0 || currentDocId !== report.document_id);
                                currentDocId = report.document_id;

                                // Create combined row with header and detail data
                                const combinedRow = this.createCombinedRow(report, this.checkedHeaderFields, this.checkedDetailFields, NO_SUBTOTAL_FIELDS, subtotals);
                                finalData.push(combinedRow);

                                grandTotalQuantity += parseFloat(report.quantity || 0);
                                //grandTotalPrice += parseFloat(report.price || 0);
                                grandTotalNetSubtotal += parseFloat(report.subtotal || 0);

                                // Add subtotal row if next record is a different document or last record
                                const isLastRecord = i === siteData.report_details.length - 1;
                                const nextRecord = siteData.report_details[i + 1];
                                if (isLastRecord || (nextRecord && nextRecord.document_id !== report.document_id)) {
                                    // finalData.push(this.createSubtotalRow(subtotals, combinedFields));
                                    //finalData.push(new Array(combinedFields.length).fill(""));
                                    subtotals = {};
                                }
                            }
                        }

                        // Add summary rows
                        const summaryRow = new Array(combinedFields.length).fill("");
                        summaryRow[combinedFields.length - 4] = "Grand Total:";
                        summaryRow[combinedFields.length - 3] = this.convertToCurrency(grandTotalQuantity);
                        summaryRow[combinedFields.length - 2] = "";
                        summaryRow[combinedFields.length - 1] = this.convertToCurrency(grandTotalNetSubtotal);
                        finalData.push(summaryRow);

                        const printed_by = secureStorage.getItem("email") || '';
                        const dateRange = `Date Range: ${this.inputDate[0].format('MMMM DD, YYYY hh:mm A')} to ${this.inputDate[1].format('MMMM DD, YYYY hh:mm A')}`;
                        const footerRow = new Array(combinedFields.length).fill("");
                        footerRow[0] = `${transactionInfo.value} Journal`;
                        footerRow[1] = `Generate By: ${printed_by}`;
                        footerRow[2] = dateRange;
                        finalData.push(footerRow);

                        // Convert to key-value format
                        this.JsonData = finalData.map(row =>
                            Object.fromEntries(
                                combinedHeaders.map((header, index) => [header, row[index] || ''])
                            )
                        );
                    }
                // } catch (error) {
                //     this.openNotificationWithIcon('error', 'An error occurred while generating the file.');
                //     console.error('Generate file error:', error);
                // } finally {
                    this.spinning = false;
                // }
            },

            downloadCSV() {
                const rows = [];

                const fileName = `${this.currentProfile.replace(/_/g, '-')}-${this.currDate.replace(/ /g, '')}.csv`;
                const fileType = 'CSV File';

                this.JsonData.forEach(item => {
                    for (const key in item) {
                        if (item.hasOwnProperty(key)) {
                            if (item[key] === "fileName") {
                                item[key] = fileName;
                            }
                            if (item[key] === "fileType") {
                                item[key] = fileType;
                            }
                        }
                    }
                });

                // Create data rows without including headers
                this.JsonData.forEach(item => {
                    const row = Object.values(item).map(value => `"${value || ''}"`); // get values and avoid null
                    rows.push(row.join(','));
                });

                // Create a Blob and trigger the download
                const csvContent = rows.join('\n');
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                this.clearJsonData()

            },

            downloadExcel() {

                const fileName = `${this.currentProfile.replace(/_/g, '-')}-${this.currDate.replace(/ /g, '')}.xlsx`;
                const fileType = 'Excel File';

                this.JsonData.forEach(item => {
                    for (const key in item) {
                        if (item.hasOwnProperty(key)) {
                            if (item[key] === "fileName") {
                                item[key] = fileName;
                            }
                            if (item[key] === "fileType") {
                                item[key] = fileType;
                            }
                        }
                    }
                });
                const ws = XLSX.utils.json_to_sheet(this.JsonData, { header: [] });

                const range = ws['!ref']; 
                const startRow = range.split(':')[0];
                const endRow = range.split(':')[1];
                const startRowIndex = parseInt(startRow.substring(1));

                const newRange = `A${startRowIndex + 1}:${endRow}`;
                ws['!ref'] = newRange;

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

                XLSX.writeFile(wb, fileName);
                this.clearJsonData()
            },

            createCombinedRow(report, headerFields, detailFields, noSubtotalFields, subtotals) {
                const headerValues = headerFields.map(field => {
                    let value = report[field];
                    if (['id','discount_text','tax_rate','tax_amount','status','created_at','updated_at','account_id'].includes(field)){
                        value = report[`document_${field}`];
                    }
                    
                        if (field === 'discount') {
                            const amountGross = parseFloat(report['amount_gross']) || 0;
                            const amountNet = parseFloat(report['amount_net']) || 0;
                            return this.convertToCurrency(amountGross - amountNet);
                        }

                        if (['document_date', 'posted_at'].includes(field)) {
                            return value ? moment(value).format('MM/DD/YYYY') : '';
                        }else if (field === 'origin_document_no') {
                            if (['sales_order_journals','price_work_sheet_journals'].includes(this.currentProfile)){
                            }else {
                                return value ? moment(value).format('MM/DD/YYYY') : '';
                            }
                        }else if (field === 'origin_document_date') {
                            if (['sales_order_journals','price_work_sheet_journals'].includes(this.currentProfile)){
                            }else {return (value === -1 || value === undefined) ? '' : value;}
                        }else if (field === 'stock_no') {
                            if (['sales_order_journals'].includes(this.currentProfile)){
                            }else{
                                return value || '';
                            }
                        }else if(field === 'document_status') {
                            if (value === 'A') return 'Active';
                            var statusOption = this.statusOptions.find(x => x.key === value).value;
                            return statusOption ? statusOption.value : '';
                        }else{
                            return value || '';
                        }
                    });
                    const detailValues = detailFields.map(field => {
                        const value = report[field];
                        if (!value) return '';
                        if (field === 'subtotal') {
                            return Number(value) - report['amount_header_discount'];
                        }
                        if (!noSubtotalFields.includes(field) && !isNaN(parseFloat(value))) {
                            const numValue = Number(value);
                            subtotals[field] = (subtotals[field] || 0) + numValue;
                            return this.convertToCurrency(numValue);
                        }
                        if (field === 'stock_no') {
                            if (['sales_order_journals'].includes(this.currentProfile)){
                            }else{
                                return value || '';
                            }
                        }else{
                            return value;
                        }
                    });

                    //const rowHeaderValues = isFirstRow ? headerValues : new Array(headerValues.length).fill('');
                    return [...headerValues, ...detailValues];
                },

            createSubtotalRow(subtotals, combinedFields) {
                const subtotalRow = new Array(combinedFields.length).fill('');
                const descriptionColumnIndex = combinedFields.findIndex(field => 
                    field === 'product_name' || field === 'description'
                );
                if (descriptionColumnIndex !== -1) {
                    subtotalRow[descriptionColumnIndex] = 'Subtotal:';
                } else {
                    subtotalRow[0] = 'Subtotal';
                }
                
                combinedFields.forEach((field, index) => {
                    if (field === 'quantity') {
                        subtotalRow[index] = this.convertToCurrency(subtotals[field]);
                    }
                    if (field === 'price') {
                        subtotalRow[index] = this.convertToCurrency(subtotals[field]);
                    }   
                    if (field === 'subtotal') {
                        subtotalRow[index] = this.convertToCurrency(subtotals[field]);
                    }
                });
                
                return subtotalRow;
            },
            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?mode=all",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;
                
            },
            async getSubBrandData() {
                if (this.inputBrands != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_ids=" +
                        this.inputBrands,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
              this.selectedFileType = 'xls'
            },
        }
    };
</script>

<style></style>
